import e from "react";
import { motion as t } from "framer-motion";
import { Button as n, Image as o, jsx as i, ThemeProvider as r } from "theme-ui";
import a from "query-string";
import { setupPostMessageHandlers as s, setupCustomEventHandlers as l, getUserInfo as u, fetchWidgetSettings as c, updateWidgetSettingsMetadata as d, isValidUuid as p } from "@papercups-io/browser";
import g from "tinycolor2";

function f() {
  return (f = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function h(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}

function m(e, t) {
  if (null == e) return {};
  var n,
      o,
      i = {},
      r = Object.keys(e);

  for (o = 0; o < r.length; o++) {
    t.indexOf(n = r[o]) >= 0 || (i[n] = e[n]);
  }

  return i;
}

var v = function v(n) {
  return e.createElement(t.path, Object.assign({
    fill: "transparent",
    strokeWidth: "3",
    stroke: "hsl(0, 0%, 99%)",
    strokeLinecap: "round"
  }, n));
},
    y = function y() {
  return e.createElement("svg", {
    width: "27",
    height: "27",
    viewBox: "0 0 27 27"
  }, e.createElement(v, {
    variants: {
      closed: {
        opacity: 0,
        d: "M 7.5 14.5 L 19 14.5"
      },
      open: {
        opacity: 1,
        d: "M 7 7 L 20 20"
      }
    },
    transition: {
      duration: .2
    }
  }), e.createElement(v, {
    variants: {
      closed: {
        opacity: 0,
        d: "M 7.5 8.5 L 19 8.5"
      },
      open: {
        opacity: 1,
        d: "M 7 20 L 20 7"
      }
    },
    transition: {
      duration: .2
    }
  }), e.createElement(v, {
    d: "M22 21.6453C22 20 23 19.5 23 19.5C23 19.5 25.5 18 25.5 14V9C25.5 4 23 1.5 18 1.5H9C4 1.5 1.5 4 1.5 9V14C1.5 19 4 21 9 21H13.5C14 21 14 21 15 21.5L20.25 24.8572L20.8517 25.2118C21.5184 25.6046 22 25.631 22 24.8572V24.0287V22.7858V21.6453Z",
    variants: {
      closed: {
        opacity: 1
      },
      open: {
        opacity: 0
      }
    },
    transition: {
      duration: .2
    }
  }));
},
    b = function b() {
  return e.createElement("svg", {
    width: "24",
    height: "25",
    viewBox: "0 0 24 25",
    fill: "none"
  }, e.createElement(v, {
    variants: {
      closed: {
        opacity: 0,
        d: "M 7.5 14.5 L 19 14.5"
      },
      open: {
        opacity: 1,
        d: "M 5 5 L 20 20"
      }
    },
    transition: {
      duration: .2
    }
  }), e.createElement(v, {
    variants: {
      closed: {
        opacity: 0,
        d: "M 7.5 8.5 L 19 8.5"
      },
      open: {
        opacity: 1,
        d: "M 5 20 L 20 5"
      }
    },
    transition: {
      duration: .2
    }
  }), e.createElement(t.path, {
    d: "M20.5 21.1453C20.5 19.5 21.5 19 21.5 19C21.5 19 24 18.5 24 13.5V8.5C24 3.5 21.5 1 16.5 1H7.5C2.5 1 0 3.5 0 8.5V13.5C0 18.5 2.5 20.5 7.5 20.5H12C12.5 20.5 12.5 20.5 13.5 21L18.75 24.3572L19.3517 24.7118C20.0184 25.1046 20.5 25.131 20.5 24.3572V23.5287V22.2858V21.1453Z",
    fill: "white",
    fillOpacity: "0.7",
    variants: {
      closed: {
        opacity: 1
      },
      open: {
        opacity: 0
      }
    },
    transition: {
      duration: .2
    }
  }), e.createElement(t.path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 18C21.5 18 20.5 18.5 20.5 20.1453V21.2858V22.5287V23.3572C20.5 24.131 20.0184 24.1046 19.3517 23.7118L18.75 23.3572L13.5 20C12.8174 19.6587 12.6007 19.5504 12.3729 19.516C12.267 19.5 12.1587 19.5 12 19.5H7.5C2.5 19.5 0 17.5 0 12.5V7.5C0 2.5 2.5 0 7.5 0H16.5C21.5 0 24 2.5 24 7.5V12.5C24 17.5 21.5 18 21.5 18ZM21 17.557C21.8581 17.557 24 13.557 23 13.057C22.3869 12.7505 21.8801 13.7414 21.4646 14.554C21.2023 15.0668 20.9764 15.5086 20.783 15.5086C20.283 15.5086 20 16.0554 20 16.7568C20 17.4582 20.1419 17.557 21 17.557Z",
    fill: "white",
    variants: {
      closed: {
        opacity: 1
      },
      open: {
        opacity: 0
      }
    },
    transition: {
      duration: .2
    }
  }));
},
    w = function w() {
  return e.createElement("svg", {
    width: "27",
    height: "27",
    viewBox: "0 0 27 27"
  }, e.createElement(v, {
    variants: {
      closed: {
        opacity: 0,
        d: "M 7.5 14.5 L 19 14.5"
      },
      open: {
        opacity: 1,
        d: "M 7 7 L 20 20"
      }
    },
    transition: {
      duration: .2
    }
  }), e.createElement(v, {
    variants: {
      closed: {
        opacity: 0,
        d: "M 7.5 8.5 L 19 8.5"
      },
      open: {
        opacity: 1,
        d: "M 7 20 L 20 7"
      }
    },
    transition: {
      duration: .2
    }
  }));
},
    C = function C(t) {
  var n = t.customIconUrl,
      i = t.iconVariant;
  return n ? t.isOpen ? e.createElement(w, null) : e.createElement(o, {
    src: n,
    style: {
      maxHeight: 40,
      maxWidth: 40
    }
  }) : e.createElement("filled" === i ? b : y, null);
},
    S = function S(t) {
  var o = t.isOpen;
  return e.createElement(n, {
    className: "Papercups-toggleButton",
    variant: "primary",
    p: 0,
    style: t.style,
    sx: {
      variant: "styles.WidgetToggle"
    },
    disabled: t.isDisabled,
    onClick: t.toggle,
    "aria-label": (o ? "Close" : "Open") + " chat widget"
  }, e.createElement(C, {
    customIconUrl: t.customIconUrl,
    iconVariant: t.iconVariant,
    isOpen: o
  }));
};

function x() {}

var I = {
  ChatWindowContainer: {
    margin: 0,
    height: "100%",
    width: "100%",
    minHeight: 320
  },
  WidgetContainer: {
    margin: 0,
    zIndex: 2147483e3,
    position: "fixed",
    bottom: 100,
    right: 20,
    width: 376,
    maxWidth: ["90%", "376px"],
    minHeight: 250,
    maxHeight: ["60%", "704px"],
    boxShadow: "rgba(0, 0, 0, 0.16) 0px 5px 40px",
    height: "calc(100% - 120px)",
    borderRadius: 8,
    overflow: "hidden",
    notifications: {
      background: "transparent",
      margin: 0,
      zIndex: 2147483e3,
      position: "fixed",
      bottom: 80,
      right: 20,
      width: "auto",
      maxWidth: ["90%", "300px"],
      minHeight: 0,
      maxHeight: ["60%", "400px"],
      boxShadow: "none",
      height: 200,
      overflow: "hidden"
    }
  },
  WidgetToggleContainer: {
    position: "fixed",
    zIndex: 2147483003,
    bottom: "20px",
    right: "20px"
  },
  WidgetToggle: {
    outline: "none !important",
    border: "none !important",
    userSelect: "none !important",
    cursor: "pointer",
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
},
    _ = "__PAPERCUPS__",
    O = function O(e, t) {
  void 0 === t && (t = "local");

  try {
    switch (t) {
      case "local":
        return function (e) {
          try {
            var t = e && e.localStorage;
            return f({}, t, {
              get: function get(e) {
                var n = t.getItem("" + _ + e);
                if (!n) return null;

                try {
                  return JSON.parse(n);
                } catch (e) {
                  return n;
                }
              },
              set: function set(e, n) {
                t.setItem("" + _ + e, JSON.stringify(n));
              },
              remove: function remove(e) {
                t.removeItem(e);
              }
            });
          } catch (e) {
            return {
              _db: {},
              getItem: function getItem(e) {
                return this._db[e] || null;
              },
              setItem: function setItem(e, t) {
                this._db[e] = t;
              },
              removeItem: function removeItem(e) {
                delete this._db[e];
              },
              get: function get(e) {
                return this._db[e] || null;
              },
              set: function set(e, t) {
                this._db[e] = t;
              },
              remove: function remove(e) {
                delete this._db[e];
              }
            };
          }
        }(e);

      case "session":
        return function (e) {
          try {
            var t = e && e.sessionStorage;
            return f({}, t, {
              get: function get(e) {
                var n = t.getItem("" + _ + e);
                if (!n) return null;

                try {
                  return JSON.parse(n);
                } catch (e) {
                  return n;
                }
              },
              set: function set(e, n) {
                t.setItem("" + _ + e, JSON.stringify(n));
              },
              remove: function remove(e) {
                t.removeItem(e);
              }
            });
          } catch (e) {
            return {
              _db: {},
              getItem: function getItem(e) {
                return this._db[e] || null;
              },
              setItem: function setItem(e, t) {
                this._db[e] = t;
              },
              removeItem: function removeItem(e) {
                delete this._db[e];
              },
              get: function get(e) {
                return this._db[e] || null;
              },
              set: function set(e, t) {
                this._db[e] = t;
              },
              remove: function remove(e) {
                delete this._db[e];
              }
            };
          }
        }(e);

      case "cookie":
        return function () {
          try {
            throw new Error("Cookie storage has not been implemented!");
          } catch (e) {
            return {
              _db: {},
              getItem: function getItem(e) {
                return this._db[e] || null;
              },
              setItem: function setItem(e, t) {
                this._db[e] = t;
              },
              removeItem: function removeItem(e) {
                delete this._db[e];
              },
              get: function get(e) {
                return this._db[e] || null;
              },
              set: function set(e, t) {
                this._db[e] = t;
              },
              remove: function remove(e) {
                delete this._db[e];
              }
            };
          }
        }();

      case "memory":
      default:
        return {
          _db: {},
          getItem: function getItem(e) {
            return this._db[e] || null;
          },
          setItem: function setItem(e, t) {
            this._db[e] = t;
          },
          removeItem: function removeItem(e) {
            delete this._db[e];
          },
          get: function get(e) {
            return this._db[e] || null;
          },
          set: function set(e, t) {
            this._db[e] = t;
          },
          remove: function remove(e) {
            delete this._db[e];
          }
        };
    }
  } catch (e) {
    return {
      _db: {},
      getItem: function getItem(e) {
        return this._db[e] || null;
      },
      setItem: function setItem(e, t) {
        this._db[e] = t;
      },
      removeItem: function removeItem(e) {
        delete this._db[e];
      },
      get: function get(e) {
        return this._db[e] || null;
      },
      set: function set(e, t) {
        this._db[e] = t;
      },
      remove: function remove(e) {
        delete this._db[e];
      }
    };
  }
},
    T = function () {
  function e(e) {
    this.debugModeEnabled = !!e;
  }

  var t = e.prototype;
  return t.debug = function () {
    var e;

    if (this.debugModeEnabled) {
      for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) {
        n[o] = arguments[o];
      }

      (e = console).debug.apply(e, ["[Papercups]"].concat(n));
    }
  }, t.log = function () {
    var e;

    if (this.debugModeEnabled) {
      for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) {
        n[o] = arguments[o];
      }

      (e = console).log.apply(e, ["[Papercups]"].concat(n));
    }
  }, t.info = function () {
    for (var e, t = arguments.length, n = new Array(t), o = 0; o < t; o++) {
      n[o] = arguments[o];
    }

    (e = console).info.apply(e, ["[Papercups]"].concat(n));
  }, t.warn = function () {
    for (var e, t = arguments.length, n = new Array(t), o = 0; o < t; o++) {
      n[o] = arguments[o];
    }

    (e = console).warn.apply(e, ["[Papercups]"].concat(n));
  }, t.error = function () {
    for (var e, t = arguments.length, n = new Array(t), o = 0; o < t; o++) {
      n[o] = arguments[o];
    }

    (e = console).error.apply(e, ["[Papercups]"].concat(n));
  }, e;
}(),
    E = function (e) {
  function t(t) {
    var n;
    (n = e.call(this, t) || this).subscriptions = [], n.logger = new T(), n.EVENTS = ["papercups:open", "papercups:close", "papercups:toggle", "papercups:identify", "papercups:customer:set", "storytime:customer:set"], n.shouldUpdateCustomer = function (e, t) {
      if (!e) return !1;
      if (e && !t) return !0;
      var n = e || {},
          o = n.metadata,
          i = void 0 === o ? {} : o,
          r = m(n, ["metadata"]),
          a = t || {},
          s = a.metadata,
          l = void 0 === s ? {} : s,
          u = m(a, ["metadata"]),
          c = Object.keys(r).every(function (e) {
        return r[e] === u[e];
      }),
          d = Object.keys(i).every(function (e) {
        return i[e] === l[e];
      });
      return !(c && d);
    }, n.getDefaultTitle = function (e) {
      try {
        var t = n.props,
            o = t.title,
            i = t.setDefaultTitle;
        return Promise.resolve(i && "function" == typeof i ? i(e) : o || e.title);
      } catch (e) {
        return Promise.reject(e);
      }
    }, n.getDefaultSubtitle = function (e) {
      try {
        var t = n.props,
            o = t.subtitle,
            i = t.setDefaultSubtitle;
        return Promise.resolve(i && "function" == typeof i ? i(e) : o || e.subtitle);
      } catch (e) {
        return Promise.reject(e);
      }
    }, n.getDefaultGreeting = function (e) {
      try {
        var t = n.props,
            o = t.greeting,
            i = t.setDefaultGreeting;
        return Promise.resolve(i && "function" == typeof i ? i(e) : o || e.greeting);
      } catch (e) {
        return Promise.reject(e);
      }
    }, n.setIframeRef = function (e) {
      n.iframeRef = e;
    }, n.getIframeUrl = function () {
      return n.props.iframeUrlOverride || "https://chat-widget.papercups.io";
    }, n.handleConfigUpdated = function (e) {
      n.setState({
        config: f({}, n.state.config, e)
      }), n.send("config:update", e);
    }, n.handleSetCustomerId = function (e) {
      var t = n.storage.getCustomerId(),
          o = e || t;
      n.logger.debug("Setting customer ID:", o), n.setState({
        config: f({}, n.state.config, {
          customerId: o
        })
      }), n.send("customer:set:id", o);
    }, n.handleCustomerIdUpdated = function (e) {
      var t = n.storage.getCustomerId(),
          o = e || t,
          i = f({}, n.state.config, {
        customerId: o
      });
      n.setState({
        config: i,
        query: a.stringify(i, {
          skipEmptyString: !0,
          skipNull: !0
        })
      }), n.logger.debug("Updated customer ID:", o);
    }, n.fetchWidgetSettings = function () {
      try {
        var e = n.props,
            t = {};
        return Promise.resolve(c({
          account_id: e.accountId || e.token,
          inbox_id: e.inbox
        }, e.baseUrl).then(function (e) {
          return e || t;
        }).catch(function () {
          return t;
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    }, n.updateWidgetSettingsMetadata = function () {
      try {
        var e = n.props,
            t = e.baseUrl,
            o = {
          account_id: e.accountId || e.token,
          inbox_id: e.inbox,
          metadata: u(window)
        };
        return Promise.resolve(d(o, t).catch(function (e) {
          n.logger.error("Failed to update widget metadata:", e);
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    }, n.hasValidPayloadIdentity = function (e) {
      var t = e && e.ts,
          o = n.state.config;
      return !t || (void 0 === o ? {} : o).ts === t;
    }, n.customEventHandlers = function (e) {
      if (!e || !e.type) return null;
      var t = e.detail;

      switch (e.type) {
        case "papercups:open":
          return n.handleOpenWidget();

        case "papercups:close":
          return n.handleCloseWidget();

        case "papercups:toggle":
          return n.handleToggleOpen();

        case "papercups:customer:set":
          return n.handleSetCustomerId(t);

        case "storytime:customer:set":
          return n.handleCustomerIdUpdated(t);

        default:
          return null;
      }
    }, n.postMessageHandlers = function (e) {
      n.logger.debug("Handling in parent:", e.data);
      var t = n.getIframeUrl(),
          o = new URL(t);
      if (e.origin !== o.origin) return null;
      var i = e.data,
          r = i.event,
          a = i.payload,
          s = void 0 === a ? {} : a;
      if (!n.hasValidPayloadIdentity(s)) return n.logger.warn("Payload identifer from iframe does not match parent — halting message handlers."), null;

      switch (r) {
        case "chat:loaded":
          return n.handleChatLoaded();

        case "customer:created":
        case "customer:updated":
          return n.handleCacheCustomerId(s);

        case "conversation:join":
          return n.sendCustomerUpdate(s);

        case "message:received":
          return n.handleMessageReceived(s);

        case "message:sent":
          return n.handleMessageSent(s);

        case "messages:unseen":
          return n.handleUnseenMessages(s);

        case "messages:seen":
          return n.handleMessagesSeen();

        case "papercups:open":
        case "papercups:close":
          return n.handleToggleOpen();

        default:
          return null;
      }
    }, n.send = function (e, t) {
      n.logger.debug("Sending from parent:", {
        event: e,
        payload: t
      });
      var o = n.iframeRef;
      if (!o) throw new Error("Attempted to send event " + e + " with payload " + JSON.stringify(t) + " before iframeRef was ready");
      o.contentWindow.postMessage({
        event: e,
        payload: t
      }, n.getIframeUrl());
    }, n.handleMessageReceived = function (e) {
      var t = n.props.onMessageReceived,
          o = void 0 === t ? x : t;
      e.user_id && !e.customer_id && o && o(e);
    }, n.handleMessageSent = function (e) {
      var t = n.props.onMessageSent,
          o = void 0 === t ? x : t;
      o && o(e);
    }, n.handleUnseenMessages = function (e) {
      n.logger.debug("Handling unseen messages:", e), n.setState({
        shouldDisplayNotifications: !0
      }), n.send("notifications:display", {
        shouldDisplayNotifications: !0
      });
    }, n.handleMessagesSeen = function () {
      n.logger.debug("Handling messages seen"), n.setState({
        shouldDisplayNotifications: !1
      }), n.storage.setPopupSeen(!0), n.send("notifications:display", {
        shouldDisplayNotifications: !1
      });
    }, n.shouldOpenByDefault = function () {
      var e = n.props,
          t = e.defaultIsOpen,
          o = e.isOpenByDefault,
          i = e.persistOpenState;
      if (!e.canToggle) return !0;
      var r = n.storage.getOpenState();
      return i ? r : !(!o && !t);
    }, n.handleChatLoaded = function () {
      n.setState({
        isLoaded: !0
      });
      var e = n.state.config,
          t = (void 0 === e ? {} : e).subscriptionPlan,
          o = void 0 === t ? null : t,
          i = n.props,
          r = i.popUpInitialMessage,
          a = i.onChatLoaded,
          s = void 0 === a ? x : a;
      s && "function" == typeof s && s({
        open: n.handleOpenWidget,
        close: n.handleCloseWidget,
        identify: n.identify
      }), n.shouldOpenByDefault() && n.setState({
        isOpen: !0
      }, function () {
        return n.emitToggleEvent(!0);
      }), r && !n.storage.getPopupSeen() && setTimeout(function () {
        n.setState({
          shouldDisplayNotifications: !0
        }), n.send("notifications:display", {
          shouldDisplayNotifications: !0,
          popUpInitialMessage: !0
        });
      }, "number" == typeof r ? r : 0), n.send("papercups:plan", {
        plan: o
      });
    }, n.formatCustomerMetadata = function (e) {
      return e ? Object.keys(e).reduce(function (t, n) {
        var o, i;
        return f({}, t, "metadata" === n ? ((o = {})[n] = e[n], o) : ((i = {})[n] = String(e[n]), i));
      }, {}) : {};
    }, n.identify = function (e) {
      return n.updateCustomerMetadata(n.state.config.customerId, e);
    }, n.updateCustomerMetadata = function (e, t) {
      var o = f({}, u(window), n.formatCustomerMetadata(t));
      return n.send("customer:update", {
        customerId: e,
        metadata: o
      });
    }, n.sendCustomerUpdate = function (e) {
      n.updateCustomerMetadata(e.customerId, n.props.customer);
    }, n.handleCacheCustomerId = function (e) {
      var t = e.customerId;
      n.logger.debug("Caching customer ID:", t), window.dispatchEvent(new CustomEvent("papercups:customer:set", {
        detail: t
      })), n.storage.setCustomerId(t), n.setState({
        config: f({}, n.state.config, {
          customerId: t
        })
      });
    }, n.emitToggleEvent = function (e) {
      n.send("papercups:toggle", {
        isOpen: e
      });
      var t = n.props,
          o = t.persistOpenState,
          i = t.onChatOpened,
          r = void 0 === i ? x : i,
          a = t.onChatClosed,
          s = void 0 === a ? x : a;
      void 0 !== o && o && n.storage.setOpenState(e), e ? r && r() : s && s();
    }, n.handleOpenWidget = function () {
      n.props.canToggle && !n.state.isOpen && (n.state.shouldDisplayNotifications ? n.setState({
        isTransitioning: !0
      }, function () {
        setTimeout(function () {
          n.setState({
            isOpen: !0,
            isTransitioning: !1
          }, function () {
            return n.emitToggleEvent(!0);
          });
        }, 200);
      }) : n.setState({
        isOpen: !0
      }, function () {
        return n.emitToggleEvent(!0);
      }));
    }, n.handleCloseWidget = function () {
      n.props.canToggle && n.state.isOpen && n.setState({
        isOpen: !1
      }, function () {
        return n.emitToggleEvent(!1);
      });
    }, n.handleToggleOpen = function () {
      var e = n.state,
          t = e.isOpen,
          o = !t;
      e.isLoaded && n.props.canToggle && (!t && e.shouldDisplayNotifications ? n.setState({
        isTransitioning: !0
      }, function () {
        setTimeout(function () {
          n.setState({
            isOpen: o,
            isTransitioning: !1
          }, function () {
            return n.emitToggleEvent(o);
          });
        }, 200);
      }) : n.setState({
        isOpen: o
      }, function () {
        return n.emitToggleEvent(o);
      }));
    };
    var o = t.token || t.accountId;
    if (!o) throw new Error("A `token` is required to run the Papercups chat!");
    if (!p(o)) throw console.error("The `token` must be a valid UUID. (Received invalid `token`: " + o + ")"), console.error("If you're missing a Papercups `token`, you can get one by signing up for a free account at https://app.papercups.io/register"), new Error("Invalid `token`: " + o);
    return n.state = {
      isOpen: !1,
      isLoaded: !1,
      query: "",
      config: {},
      shouldDisplayNotifications: !1,
      isTransitioning: !1
    }, n;
  }

  h(t, e);
  var n = t.prototype;
  return n.componentDidMount = function () {
    try {
      var e = this,
          t = +new Date(),
          n = e.props,
          o = n.token,
          i = n.inbox,
          r = n.accountId,
          c = n.primaryColor,
          d = n.baseUrl,
          p = n.awayMessage,
          g = n.newMessagePlaceholder,
          h = n.emailInputPlaceholder,
          m = n.newMessagesNotificationText,
          v = n.agentAvailableText,
          y = n.agentUnavailableText,
          b = n.showAgentAvailability,
          w = n.requireEmailUpfront,
          C = n.disableAnalyticsTracking,
          S = n.canToggle,
          x = n.customer,
          I = void 0 === x ? {} : x,
          _ = n.debug,
          E = void 0 !== _ && _;
      return e.logger = new T(!!E), e.subscriptions = [s(window, e.postMessageHandlers), l(window, e.EVENTS, e.customEventHandlers)], e.storage = function (e, t) {
        void 0 === t && (t = {});
        var n = t.defaultType,
            o = t.openStateType,
            i = void 0 === o ? "session" : o,
            r = O(e, void 0 === n ? "local" : n),
            a = O(e, i);
        return {
          getCustomerId: function getCustomerId() {
            return r.get("__CUSTOMER_ID__");
          },
          setCustomerId: function setCustomerId(e) {
            return r.set("__CUSTOMER_ID__", e);
          },
          removeCustomerId: function removeCustomerId() {
            return r.remove("__CUSTOMER_ID__");
          },
          getOpenState: function getOpenState() {
            return a.get(":open");
          },
          setOpenState: function setOpenState(e) {
            return a.set(":open", e);
          },
          clearOpenState: function clearOpenState() {
            return a.remove(":open");
          },
          getPopupSeen: function getPopupSeen() {
            return a.get(":pop_up_seen");
          },
          setPopupSeen: function setPopupSeen(e) {
            return a.set(":pop_up_seen", e);
          },
          clearPopupSeen: function clearPopupSeen() {
            return a.remove(":pop_up_seen");
          }
        };
      }(window), Promise.resolve(e.fetchWidgetSettings()).then(function (n) {
        var s = f({}, u(window), I);
        return Promise.resolve(e.getDefaultTitle(n)).then(function (l) {
          return Promise.resolve(e.getDefaultSubtitle(n)).then(function (u) {
            var f = c || n.color;
            return Promise.resolve(e.getDefaultGreeting(n)).then(function (c) {
              var x,
                  I,
                  _,
                  O = {
                baseUrl: d,
                inbox: i,
                token: o || r,
                accountId: o || r,
                title: l,
                subtitle: u,
                primaryColor: f,
                greeting: c,
                awayMessage: p || n.away_message,
                newMessagePlaceholder: g || n.new_message_placeholder,
                emailInputPlaceholder: h || n.email_input_placeholder,
                newMessagesNotificationText: m || n.new_messages_notification_text,
                companyName: null == n || null === (x = n.account) || void 0 === x ? void 0 : x.company_name,
                requireEmailUpfront: w || n.require_email_upfront ? 1 : 0,
                showAgentAvailability: b || n.show_agent_availability ? 1 : 0,
                agentAvailableText: n.agent_available_text || v,
                agentUnavailableText: n.agent_unavailable_text || y,
                closeable: S ? 1 : 0,
                customerId: e.storage.getCustomerId(),
                subscriptionPlan: null == n || null === (I = n.account) || void 0 === I ? void 0 : I.subscription_plan,
                isOutsideWorkingHours: null == n || null === (_ = n.account) || void 0 === _ ? void 0 : _.is_outside_working_hours,
                isBrandingHidden: null == n ? void 0 : n.is_branding_hidden,
                metadata: JSON.stringify(s),
                disableAnalyticsTracking: C ? 1 : 0,
                debug: E ? 1 : 0,
                version: "1.3.0",
                ts: t.toString()
              },
                  T = a.stringify(O, {
                skipEmptyString: !0,
                skipNull: !0
              });

              return e.setState({
                config: O,
                query: T
              }), Promise.resolve(e.updateWidgetSettingsMetadata()).then(function () {});
            });
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, n.componentWillUnmount = function () {
    this.subscriptions.forEach(function (e) {
      "function" == typeof e && e();
    });
  }, n.componentDidUpdate = function (e) {
    if (this.state.isLoaded) {
      var t = this.props,
          n = t.token,
          o = t.inbox,
          i = t.accountId,
          r = t.title,
          a = t.subtitle,
          s = t.primaryColor,
          l = t.baseUrl,
          u = t.greeting,
          c = t.newMessagePlaceholder,
          d = t.emailInputPlaceholder,
          p = t.newMessagesNotificationText,
          g = t.requireEmailUpfront,
          f = t.showAgentAvailability,
          h = t.agentAvailableText,
          m = t.agentUnavailableText,
          v = t.customer,
          y = [e.token, e.inbox, e.accountId, e.title, e.subtitle, e.primaryColor, e.baseUrl, e.greeting, e.newMessagePlaceholder, e.emailInputPlaceholder, e.newMessagesNotificationText, e.requireEmailUpfront, e.showAgentAvailability, e.agentAvailableText, e.agentUnavailableText],
          b = this.state.config.customerId;
      [n, o, i, r, a, s, l, u, c, d, p, g, f, h, m].some(function (e, t) {
        return e !== y[t];
      }) && this.handleConfigUpdated({
        token: n,
        inbox: o,
        accountId: i,
        title: r,
        subtitle: a,
        primaryColor: s,
        baseUrl: l,
        greeting: u,
        newMessagePlaceholder: c,
        emailInputPlaceholder: d,
        newMessagesNotificationText: p,
        agentAvailableText: h,
        agentUnavailableText: m,
        requireEmailUpfront: g ? 1 : 0,
        showAgentAvailability: f ? 1 : 0
      }), this.shouldUpdateCustomer(v, e.customer) && this.updateCustomerMetadata(b, v);
    }
  }, n.render = function () {
    var e = this.state,
        t = e.isOpen,
        n = e.isLoaded,
        o = e.query,
        a = e.config,
        s = e.shouldDisplayNotifications,
        l = e.isTransitioning,
        u = this.props,
        c = u.customIconUrl,
        d = u.hideOutsideWorkingHours,
        p = u.children,
        h = a.primaryColor;
    if (!o) return null;
    if (void 0 !== d && d && a.isOutsideWorkingHours) return null;
    var m,
        v,
        y,
        b = this.getIframeUrl(),
        w = (t || s) && !l,
        C = {
      useBodyStyles: !1,
      space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
      fonts: {
        body: '-apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue",sans-serif;',
        heading: '-apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue",sans-serif;',
        monospace: '"Roboto Mono", monospace'
      },
      fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 96],
      fontWeights: {
        body: 400,
        heading: 600,
        bold: 600
      },
      lineHeights: {
        body: 1.5,
        heading: 1.125
      },
      colors: {
        text: "#141414",
        background: "#fff",
        primary: (y = {
          primary: (v = g(void 0 === (m = h) ? "#1890ff" : m)).toString(),
          light: v.lighten().toString(),
          dark: v.darken().toString()
        }).primary,
        secondary: "#722ed1",
        muted: "#f0f0f0",
        gray: "rgba(0, 0, 0, 0.45)",
        input: "rgba(0, 0, 0, 0.65)",
        offset: "rgba(255, 255, 255, 0.8)"
      },
      text: {
        default: {
          color: "text",
          fontSize: 1
        },
        caps: {
          textTransform: "uppercase",
          letterSpacing: "0.2em"
        },
        heading: {
          fontFamily: "heading",
          fontWeight: "heading",
          lineHeight: "heading"
        }
      },
      buttons: {
        primary: {
          cursor: "pointer",
          outline: 0,
          boxShadow: "rgba(0, 0, 0, 0.08) 0 2px 4px",
          transition: "0.2s",
          "&:hover": {
            background: y.light,
            borderColor: y.light,
            boxShadow: "rgba(0, 0, 0, 0.12) 0px 2px 8px"
          },
          "&:active": {
            background: y.dark,
            borderColor: y.dark
          }
        }
      },
      styles: f({
        root: {
          fontFamily: "body",
          lineHeight: "body",
          fontWeight: "body",
          fontSize: 1
        },
        h1: {
          color: "text",
          fontFamily: "heading",
          lineHeight: "heading",
          fontWeight: "heading",
          fontSize: 5
        },
        h2: {
          color: "text",
          fontFamily: "heading",
          lineHeight: "heading",
          fontWeight: "heading",
          fontSize: 4
        },
        h3: {
          color: "text",
          fontFamily: "heading",
          lineHeight: "heading",
          fontWeight: "heading",
          fontSize: 3
        },
        h4: {
          color: "text",
          fontFamily: "heading",
          lineHeight: "heading",
          fontWeight: "heading",
          fontSize: 2
        },
        h5: {
          color: "text",
          fontFamily: "heading",
          lineHeight: "heading",
          fontWeight: "heading",
          fontSize: 1
        },
        h6: {
          color: "text",
          fontFamily: "heading",
          lineHeight: "heading",
          fontWeight: "heading",
          fontSize: 0
        },
        p: {
          color: "text",
          fontFamily: "body",
          fontWeight: "body",
          lineHeight: "body"
        },
        a: {
          color: "primary"
        },
        pre: {
          fontFamily: "monospace",
          overflowX: "auto",
          code: {
            color: "inherit"
          }
        },
        code: {
          fontFamily: "monospace",
          fontSize: "inherit"
        },
        table: {
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: 0
        },
        th: {
          textAlign: "left",
          borderBottomStyle: "solid"
        },
        td: {
          textAlign: "left",
          borderBottomStyle: "solid"
        },
        img: {
          maxWidth: "100%"
        },
        textarea: {
          transparent: {
            border: "none",
            boxShadow: "none",
            resize: "none",
            outline: 0,
            "&:hover": {
              border: "none",
              boxShadow: "none",
              resize: "none",
              outline: 0
            },
            "&:active": {
              border: "none",
              boxShadow: "none",
              resize: "none",
              outline: 0
            },
            "&:focus": {
              border: "none",
              boxShadow: "none",
              resize: "none",
              outline: 0
            }
          }
        }
      }, I)
    },
        S = ["allow-scripts", "allow-popups", "allow-same-origin", "allow-forms"].join(" ");
    return i(r, {
      theme: C
    }, p({
      sandbox: S,
      isLoaded: n,
      isActive: w,
      isOpen: t,
      isTransitioning: l,
      customIconUrl: c,
      iframeUrl: b,
      query: o,
      shouldDisplayNotifications: s,
      setIframeRef: this.setIframeRef,
      onToggleOpen: this.handleToggleOpen
    }));
  }, t;
}(e.Component),
    M = function (e) {
  function t() {
    var t;
    return (t = e.apply(this, arguments) || this).state = {
      error: null
    }, t;
  }

  h(t, e), t.getDerivedStateFromError = function (e) {
    return {
      error: e
    };
  };
  var n = t.prototype;
  return n.componentDidCatch = function (e, t) {
    console.error("Error rendering Papercups chat:", e, t);
  }, n.render = function () {
    return this.state.error ? null : this.props.children;
  }, t;
}(e.Component),
    U = function U(n) {
  return i(M, null, i(E, Object.assign({}, n, {
    canToggle: !0
  }), function (o) {
    var r = o.sandbox,
        a = o.isLoaded,
        s = o.isActive,
        l = o.isOpen,
        u = o.isTransitioning,
        c = o.customIconUrl,
        d = o.iframeUrl,
        p = o.query,
        g = o.shouldDisplayNotifications,
        h = o.setIframeRef,
        m = o.onToggleOpen,
        v = n.hideToggleButton,
        y = n.iconVariant,
        b = n.renderToggleButton,
        w = n.position,
        C = n.styles,
        x = function (e, t) {
      void 0 === e && (e = {});
      var n = e.chatContainer,
          o = void 0 === n ? {} : n,
          i = e.toggleContainer,
          r = void 0 === i ? {} : i,
          a = e.toggleButton,
          s = void 0 === a ? {} : a,
          l = t.side,
          u = t.offset,
          c = void 0 === u ? 20 : u;

      switch (void 0 === l ? "right" : l) {
        case "left":
          return {
            chatContainer: f({
              left: c,
              right: "auto"
            }, o),
            toggleContainer: f({
              left: c,
              right: "auto"
            }, r),
            toggleButton: s
          };

        case "right":
        default:
          return {
            chatContainer: f({
              right: c,
              left: "auto"
            }, o),
            toggleContainer: f({
              right: c,
              left: "auto"
            }, r),
            toggleButton: s
          };
      }
    }(void 0 === C ? {} : C, function (e) {
      if (!e) return {
        side: "right",
        offset: 20
      };

      switch (e) {
        case "left":
          return {
            side: "left",
            offset: 20
          };

        case "right":
          return {
            side: "right",
            offset: 20
          };

        default:
          return e;
      }
    }(void 0 === w ? "right" : w)),
        I = x.chatContainer,
        _ = x.toggleContainer,
        O = void 0 === _ ? {} : _,
        T = x.toggleButton,
        E = void 0 === T ? {} : T;

    return i(e.Fragment, null, i(t.iframe, {
      ref: h,
      title: "Papercups Chat Widget Container",
      className: "Papercups-chatWindowContainer",
      sandbox: r,
      animate: s ? "open" : "closed",
      initial: "closed",
      variants: {
        closed: {
          opacity: 0,
          y: 4
        },
        open: {
          opacity: 1,
          y: 0
        }
      },
      transition: {
        duration: .2,
        ease: "easeIn"
      },
      src: d + "?" + p,
      style: s ? void 0 === I ? {} : I : {
        pointerEvents: "none",
        height: 0,
        minHeight: 0
      },
      sx: {
        border: "none",
        bg: "background",
        variant: !l && g ? "styles.WidgetContainer.notifications" : "styles.WidgetContainer"
      }
    }, "Loading..."), a && !v && i(t.div, {
      className: "Papercups-toggleButtonContainer",
      initial: !1,
      style: O,
      animate: l ? "open" : "closed",
      sx: {
        variant: "styles.WidgetToggleContainer"
      }
    }, b && "function" == typeof b ? b({
      isOpen: l,
      onToggleOpen: m,
      isDisabled: u
    }) : i(S, {
      style: E,
      isDisabled: u,
      isOpen: l,
      customIconUrl: c,
      iconVariant: y,
      toggle: m
    })));
  }));
},
    P = function P(e) {
  return i(M, null, i(E, Object.assign({}, e, {
    canToggle: !1
  }), function (e) {
    var n = e.isLoaded;
    return i(t.iframe, {
      ref: e.setIframeRef,
      className: "Papercups-chatWindowContainer",
      sandbox: e.sandbox,
      animate: n ? "open" : "closed",
      initial: "closed",
      variants: {
        closed: {
          opacity: 0
        },
        open: {
          opacity: 1
        }
      },
      transition: {
        duration: .2,
        ease: "easeIn"
      },
      src: e.iframeUrl + "?" + e.query,
      sx: {
        opacity: n ? 1 : 0,
        border: "none",
        bg: "background",
        variant: "styles.ChatWindowContainer"
      }
    }, "Loading...");
  }));
},
    k = function k() {
  return window.dispatchEvent(new Event("papercups:open"));
},
    W = function W() {
  return window.dispatchEvent(new Event("papercups:close"));
},
    D = function D() {
  return window.dispatchEvent(new Event("papercups:toggle"));
},
    H = function H() {
  console.warn("`Papercups.identify` has not been implemented yet!");
},
    N = {
  open: k,
  close: W,
  toggle: D
};

export default U;
export { U as ChatWidget, P as ChatWindow, N as Papercups, W as close, H as identify, k as open, D as toggle };